<template>
	<div class="pingzheng">
        <main>
            <span>起止日期： </span>
            <el-date-picker
                v-model="time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy 年 MM 月 dd 日"
                value-format="yyyy-MM-dd">
            </el-date-picker>

            <el-button style="margin-left:20px" type="success" icon="el-icon-search" @click="search()">搜索</el-button>
            <el-button type="info" icon="el-icon-download" @click="daochu()">导出</el-button>

        </main>
        
        <el-card style="border: solid #ccc 1px">
            <el-table
                :data="tableData"
                stripe
                border
                height="60vh"
                style="width: 200%">

                <el-table-column
                    width="160"
                    prop="create_time"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    width="100"
                    prop="name"
                    label="姓名">
                </el-table-column>

                <el-table-column
                    prop="tell"
                    width="100"
                    label="手机">
                </el-table-column>

                <el-table-column
                    prop="dx_org"
                    width="100"
                    label="举报对象公司">
                </el-table-column>

                <el-table-column 
                    prop="dx_name"
                    width="100"
                    label="举报对象姓名">
                </el-table-column>

                <el-table-column
                    width='400'
                    prop="message1"
                    label="涉及问题">
                </el-table-column>

                <el-table-column
                    width='400'
                    prop="message2"
                    label="举报内容">
                </el-table-column>

                <el-table-column
                    prop="code"
                    label="查询码">
                </el-table-column>

                <el-table-column
                    width="400"
                    label="照片">
                    <template slot-scope="scope">
                        <span v-for="(item,i) in (scope.row.url).split(',')">
                            <el-popover
                                placement="bottom"
                                trigger="click">
                                <img :src="item" alt="" style="width:500px;height:500px" v-if="item">
                                <img :src="item" alt="" style="width:100px;height:100px;margin-right:20px" slot="reference"  v-if="item">
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>

                <el-table-column
                    width="200"
                    prop="fankui"
                    label="反馈">
                </el-table-column>

                <el-table-column
                    width="100"
                    prop="time"
                    label="反馈时间">
                </el-table-column>

                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <p style="color:#409EFF" v-if="scope.row.status==0">待受理</p>
                        <p style="color:#E6A23C" v-if="scope.row.status==1">已受理</p>
                        <p style="color:#67C23A" v-if="scope.row.status==2">已完结</p>
                        <p style="color:#F56C6C" v-if="scope.row.status==3">已拒绝</p>
                    </template>
                </el-table-column>

                <el-table-column label="审核" width="160">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status==0 || scope.row.status==1">
                            <el-button type="text" @click="caoZuo(scope.row.id,1)" >受理</el-button>
                            <el-button type="text" style="color:#67C23A" @click="caoZuo(scope.row.id,2)" >完结</el-button>
                            <el-button type="text" style="color:#F56C6C" @click="caoZuo(scope.row.id,3)" >拒绝</el-button>
                        </div>
                    </template>
                </el-table-column>

            </el-table>

            <el-pagination
                style="margin:20px 0"
                background
                @current-change="handleCurrentChange"
                :current-page="current_page"
                :page-size="per_page"
                layout="prev, pager, next"
                :total="total">
            </el-pagination>

        </el-card>    
        
        <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="500px">
                <el-input  type="textarea" style="width:100%" v-model="fankui" placeholder="意见" :autosize="{ minRows: 4,}"></el-input>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="fanKuiSure()">确 定</el-button>
                </span>
        </el-dialog>

    </div>
</template> 

<script>
    import { url } from '../router/api';
	export default{
		data(){
			return{
                total: 1,
                per_page: 50,
                current_page: 1,
                tableData: [],
                time:[],

                dialogVisible:false,
                title:'',
                fankui:'',
                id:'',
                
            }
        },
        async mounted() {
            var date = new Date();
            date.setTime(date.getTime());
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = (date.getDate() < 10 ? '0'+(date.getDate()) : date.getDate());
            var time1 = Y + M + '01'
            var time2 = Y + M +D
            this.time.push(time1)
            this.time.push(time2)

            await this.getList()
        },
		methods: {
            caoZuo(id,status) {
                this.id = ''
                if(status==1) {
                    this.$confirm('是否受理?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.axios.get(url+'complaint/caoZuo', {
                            params:{
                                id:id,
                                status:status,
                                fankui:' ',
                            }
                        }).then(res=> {
                            if(res.data.code==1) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.getList()
                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type:'error'
                                });
                            }
                        }).catch(err=> {
                            console.log(err);
                        });
                    }).catch(() => {});
                } else if(status==2) {
                    this.title = '完结意见'
                    this.dialogVisible = true
                    this.id = id
                } else {
                    this.title = '拒绝意见'
                    this.dialogVisible = true
                    this.id = id
                }
            },

            fanKuiSure() {
                var status = ''
                if(this.title == '完结意见') {
                    status = 2
                } else {
                    status = 3
                } 
                this.$confirm('是否确定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.axios.get(url+'complaint/caoZuo', {
                        params:{
                            id:this.id,
                            status:status,
                            fankui:this.fankui,
                        }
                    }).then(res=> {
                        if(res.data.code==1) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.dialogVisible = false;
                            this.fankui = ''
                            this.getList()
                        } else {
                            this.$message({
                                message: res.data.msg,
                                type:'error'
                            });
                        }
                    }).catch(err=> {
                        console.log(err);
                    });
                }).catch(() => {});
            },
            search() {
                this.current_page = 1
                this.getList()
            },

            handleCurrentChange(val) {
                this.current_page = val;
                this.getList();
            },
            
            getList() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url + 'complaint/searchComplaint', {
                    params:{
                        code:'',
                        time1:time1,
                        time2:time2,
                        page:this.current_page,
                        per_page:this.per_page,
                    }
                }).then(res=> {
                    loading.close();
                    this.tableData = res.data.data.data
                    this.total = res.data.data.total
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            },

            daochu() {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: '加载中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                var time1 = ''
                var time2 = ''
                if(this.time) {
                    time1 = this.time[0] + ' 00:00:00'
                    time2 = this.time[1] + ' 23:59:59'
                }
                this.axios.get(url + 'complaint/searchComplaint', {
                    params:{
                        export:1,
                        code:'',
                        time1:time1,
                        time2:time2,
                        page:this.current_page,
                        per_page:this.per_page,
                    },
                    responseType: 'blob',
                    
                }).then(res=> {
                    const data = res.data 
                    if (Object.prototype.toString.call(data) === '[object Blob]' && data.type.includes('application/vnd.ms-excel')) { 
                        const blob = res.data
                        const a = document.createElement('a')
                        let binaryData = [];
                        binaryData.push(blob);
                        const url= window.URL.createObjectURL(new Blob(binaryData));
                        a.href = url
                        a.download = '下载.csv'
                        a.click()
                        window.URL.revokeObjectURL(url)
                    }else{
                        this.$message.error('下载失败')
                    }
                    loading.close();
                }).catch(err=> {
                    loading.close();
                    console.log(err);
                });
            }
        }

    }
</script>

<style scoped="scoped" lang='less'>
    .pingzheng {
        padding-left: 10px;
        span {
            font-size: 12px;
        }
    }
    .pingzheng .el-input {
        width:140px;
        margin-right: 20px;
    }
 
    .pingzheng .el-select {
        width:140px;
        margin-right: 20px;
    }
    .pingzheng main {
        margin-bottom: 20px;
    }
    .pingzheng .el-pagination {
        white-space: nowrap;
        padding: 2px 5px;
        color: #303133;
        float: right;
        font-weight: 700;
    }
</style>

